import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import Breadcrumb from "../../shared/Breadcrumb/Breadcrumb";
import LoadingViewerTopDemo from "../ComponentDemoPage/demos/LoadingViewerTopDemo";
import styles from "../shared.module.css";

function OtherPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Other Components" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <Breadcrumb
          items={[
            { label: "Components", path: "/task-management-components" },
            { label: "Other" },
          ]}
        />

        <FixaText tagName="h2" textStyle="Heading.XL">
          Other Components
        </FixaText>

        <LoadingViewerTopDemo />
        <p>Additional miscellaneous components will be added here as needed</p>
      </FullscreenContent>
    </Fullscreen>
  );
}

export default OtherPage;
